import { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { rememberAuthenticatedRoute } from '../utils/loginReturn'

/**
 * #262 — route non authentifiée : renvoie sur `/login` EN MÉMORISANT la page
 * demandée (`state.from`), que `LoginPage` rouvre après la connexion.
 */
export function RedirectToLogin() {
  const location = useLocation()
  return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />
}

/**
 * #262 — branche authentifiée : retient la page courante de l'onglet (avec
 * son utilisateur) pour la retrouver après un retour forcé sur `/login` par
 * rechargement complet (session expirée dans `services/api.ts`, déconnexion
 * forcée par l'admin) — `location.state` n'y survit pas.
 */
export function ReturnToTracker({ userId }: { userId: string }) {
  const { pathname, search } = useLocation()
  useEffect(() => {
    rememberAuthenticatedRoute(pathname + search, userId)
  }, [pathname, search, userId])
  return null
}
